(function () {
  const TIB_SELECTOR = 'select.tee-field__select';
  const TIB_FORM = 'tee-artwork-form';
  const TEXT_INPUT_SELECTOR = '.product__block--line_item_property input[type="text"].form-control';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  function run() {
    const root = document.getElementById('product-root');
    if (!root) return;

    const marathon = (root.dataset.marathon || '').trim().toLowerCase();
    const autoAllocate = (root.dataset.autoallocate || '').trim().toLowerCase();

    if (!marathon && !autoAllocate) return;

    let userInteracted = false;

    // Stop auto-selection if the user interacts with the form
    const editor = document.getElementById(TIB_FORM);
    if (editor) {
      const setUserInteracted = () => { userInteracted = true; };
      editor.addEventListener('input', setUserInteracted, { once: true }); 
      editor.addEventListener('change', setUserInteracted, { once: true }); 
      editor.addEventListener('click', setUserInteracted, { once: true }); 
    } 

    // ROUTING LOGIC
    if (autoAllocate === 'multisport') {
      // 1. Parse URL once, outside the observer
      const params = new URLSearchParams(window.location.search);
      const targetKeys = ['first_name', 'last_name', 'race_no', 'net_time'];
      const paramValues = targetKeys.map(k => params.get(k));
      
      // 2. Only start the observer if there are actual parameters to fill
      if (paramValues.some(val => val !== null)) {
        runWithObserver(() => applyUrlPrefill(userInteracted, paramValues));
      }
    } 
    else if (autoAllocate === 'with photo') { // This is for the "with photo" radio button
      runWithObserver(() => applyRadioSelection(autoAllocate, userInteracted));
    } 
    else if (marathon) {
      runWithObserver(() => applyDropdownSelection(marathon, userInteracted));
    }
  }

  // --- HELPER FUNCTION: DOM OBSERVER ---
  function runWithObserver(applyFunc) {
    // Try immediately. If it returns true, the job is done or elements are found.
    if (applyFunc()) return;

    // If elements aren't ready, observe DOM changes
    const obs = new MutationObserver(function () {
      if (applyFunc()) obs.disconnect();
    });

    obs.observe(document.documentElement, { childList: true, subtree: true });
    
    // Safety timeout after 8 seconds
    setTimeout(function () { obs.disconnect(); }, 8000);
  }

  // --- 1. URL PARAMETER PRE-FILL LOGIC ---
  function applyUrlPrefill(userInteracted, paramValues) {
    if (userInteracted) return true;

    const textInputs = document.querySelectorAll(TEXT_INPUT_SELECTOR);
    if (!textInputs || textInputs.length === 0) return false; // Inputs not loaded yet
    
    textInputs.forEach((input, index) => {
      if (index < paramValues.length && paramValues[index] !== null && !input.value) {

        let displayValue = paramValues[index].toUpperCase();
        
        // If this is the race_no field (index 2) and it doesn't already start with #, add it
        if (index === 2 && !displayValue.startsWith('#')) {
          displayValue = '#' + displayValue;
        }

        input.value = displayValue;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    
    // Return true to disconnect observer once inputs are found and processed
    return true; 
  }

  // --- 2. RADIO BUTTON LOGIC ---
  function applyRadioSelection(key, userInteracted) {
    if (userInteracted) return true;

    const radios = document.querySelectorAll('.tee-radio');
    if (!radios || radios.length === 0) return false; // Radios not loaded yet

    for (const radioContainer of radios) {
      const labelSpan = radioContainer.querySelector('.tee-radio-label span');
      const labelText = (labelSpan?.textContent || '').trim().toLowerCase();
      
      if (labelText === key) {
        const input = radioContainer.querySelector('input.tee-checkbox-input');
        const label = radioContainer.querySelector('.tee-radio-label'); 
        if (input && label && !radioContainer.classList.contains('active')) {
          label.click();
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return true; 
      }
    }
    
    return true; // Disconnect observer if radios exist but no match is found
  }

  // --- 3. DROPDOWN SELECTOR LOGIC ---
  function applyDropdownSelection(key, userInteracted) {
    if (userInteracted) return true;

    const select = document.querySelector(TIB_SELECTOR);
    if (!select) return false; // Dropdown not loaded yet

    // Skip if selection already matches product
    if (select.selectedIndex >= 0) {
      const current = (select.options[select.selectedIndex].textContent || select.options[select.selectedIndex].label || '').trim().toLowerCase();
      if (current === key) return true; 
    }

    // Match label and select
    for (let i = 0; i < select.options.length; i++) {
      const option = select.options[i];
      const label = (option.textContent || option.label || '').trim().toLowerCase();

      if (label === key) {
        select.selectedIndex = i;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }

    return true; // Disconnect observer if dropdown exists but no match is found
  }

})();
